var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44C0 19.6995 19.6995 0 44 0V0C68.3005 0 88 19.6995 88 44V44C88 68.3005 68.3005 88 44 88V88C19.6995 88 0 68.3005 0 44V44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 7.33337C23.7599 7.33337 7.33325 23.76 7.33325 44C7.33325 64.24 23.7599 80.6667 43.9999 80.6667C64.2399 80.6667 80.6666 64.24 80.6666 44C80.6666 23.76 64.2399 7.33337 43.9999 7.33337ZM36.6666 56.8334V31.1667C36.6666 29.6634 38.3899 28.7834 39.5999 29.7L56.7233 42.5334C57.7132 43.2667 57.7132 44.7334 56.7233 45.4667L39.5999 58.3C38.3899 59.2167 36.6666 58.3367 36.6666 56.8334Z",
    fill: "url(#paint0_linear_1_5928)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5928",
    x1: 43.9999,
    y1: 7.33337,
    x2: 43.9999,
    y2: 80.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32457"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.cde6632e1dbc1beb1c35f0fd7ccc889a.svg";
export { ForwardRef as ReactComponent };